import { makeStyles } from 'tss-react/mui';
import CircleIcon from '@mui/icons-material/Circle';

const useStyles = makeStyles({ name: 'Marker' })(() => ({
  root: {
    position: 'absolute',
    height: '30px',
    width: '30px',
    left: '-15px',
    top: '-15px',
  },
}));

export const Marker = (props) => {
  const { classes } = useStyles();

  return (
    <CircleIcon
      className={classes.root}
      color="error"
      {...props}
    />
  );
};

export default Marker;
